import axios from 'axios'
import {KontStammTO} from 'generated/JavaTO'

export function getKontStammAPI(persNrs: number[], startDate: number, endDate: number) {
	return axios.get<KontStammTO[]>('../json/kont_stamm', {params: {pnrLst: persNrs, start: startDate, end: endDate}})
}